import { Menu, X, ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useUserStore } from "../../store/userStore";
import { menuItems } from "../../lib/menu";

export const Sidebar = () => {
    const location = useLocation();
    const pathname = location.pathname;

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const { user } = useUserStore();

    const userPermissions = user?.permissions || [];

    const hasPermission = (item) => {
        if (!item.permissions || item.permissions.length === 0) return true;
        return item.permissions.some((p) => userPermissions.includes(p));
    };

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsMobileMenuOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isActiveRoute = (href) => pathname === href;

    const getLinkClasses = (href, isChild = false) => {
        const baseClasses = `px-3 py-2 rounded-sm flex items-center space-x-3 cursor-pointer transition-colors duration-200 w-full ${
            isChild ? "pl-8" : ""
        }`;
        if (href && isActiveRoute(href)) {
            return `${baseClasses} bg-blue-900 text-white shadow-md`;
        }
        return `${baseClasses} text-gray-700 hover:bg-blue-900 hover:text-white`;
    };

    const toggleSubMenu = (label) => {
        setOpenSubMenu(openSubMenu === label ? null : label);
    };

    const hasActiveChild = (children) => {
        return children.some(
            (child) =>
                child.href === pathname ||
                (child.children && hasActiveChild(child.children))
        );
    };

    const renderMenu = (items, isChild = false) =>
        items.filter(hasPermission).map((item) => {
            if (item.children) {
                const isOpen =
                    openSubMenu === item.label || hasActiveChild(item.children);

                return (
                    <div key={item.label}>
                        <button
                            onClick={() => toggleSubMenu(item.label)}
                            className={getLinkClasses(null, isChild)}
                        >
                            {item.icon}
                            <span className="font-medium flex-1 text-left">{item.label}</span>
                            <ChevronDown
                                className={`h-4 w-4 transition-transform ${
                                    isOpen ? "rotate-180" : ""
                                }`}
                            />
                        </button>
                        {isOpen && (
                            <div className="ml-2 mt-1 space-y-1">
                                {renderMenu(item.children, true)}
                            </div>
                        )}
                    </div>
                );
            }

            return (
                <Link
                    key={item.href}
                    to={item.href}
                    className={getLinkClasses(item.href, isChild)}
                    onClick={() => setIsMobileMenuOpen(false)}
                >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                </Link>
            );
        });


    return (
        <>
            {/* Bouton Mobile */}
            <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="fixed top-4 left-4 z-50 p-2 bg-blue-900 text-white rounded-md md:hidden shadow-lg"
                aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

            {/* Overlay mobile */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`
          fixed left-0 top-0 bottom-0 z-40 w-64 bg-white border-r shadow-lg transform transition-transform duration-300 ease-in-out
          md:translate-x-0 md:top-16 md:shadow-sm
          ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"}
        `}
            >
                <div className="md:hidden p-4 border-b bg-blue-900 text-white">
                    <h2 className="text-lg font-semibold">Menu</h2>
                </div>

                <nav className="p-4 space-y-2 h-full overflow-y-auto">
                    {renderMenu(menuItems)}
                </nav>
            </div>

            {/* Espace réservé quand sidebar est visible en desktop */}
            <div className="hidden md:block w-64 flex-shrink-0" />
        </>
    );
};
